import React from 'react';
import { Form, Divider, Message, Button } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
// import _find from 'lodash/find';

// import EstaSeguro from '../../../components/funcionales/estaseguro'

//utils
import queries from '../../../utils/queries';

import general from '../../../modulos/general';

function getNumDiasMes(mesDias, agnoDias){
  /*
      Los meses 1,3,5,7,8,10,12 siempre tienen 31 días
      Los meses 4,6,9,11 siempre tienen 30 días
      El mes de febrero dependiendo del año puede tener 28 o 29 días
  */
  let mes = parseInt(mesDias, 10)
  let agno = parseInt(agnoDias, 10)

  if( (mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12) ) 
    return 31;
  else if( (mes === 4) || (mes === 6) || (mes === 9) || (mes === 11) ) 
    return 30;
  else if( mes === 2 )
  {
      if((agno % 4 === 0) && ((agno % 100 !== 0) || (agno % 400 === 0)))
        return 29;
      else
        return 28;
  }   
}

const styles1 ={
  paraH1:{
    padding: '0em',
    margin: '0em',
    color: '#302b63',
  },
  paraH2_01:{
  padding: '0em',
  margin: '0em',
  color: '#2C7744',
  },
  paraH2_02:{
    padding: '0em',
    margin: '0em',
    color: 'red',
  },
  colorRed:{
    color: 'red',
  },
  colorBlue:{
    color: '#302b63',
  },
  styPaddMarg:{
    padding: '0.2em 0.1em 0.2em 0.1em',
    fontSize: '0.9em'
  },
  styInput:{
  width: '4em',
  },
}

const DetalleNivelTipo = props => {
  return (
    <option dato1={props.elemento.numeroDocum} dato2={props.elemento.descrRecurso} value={props.elemento._id}>{props.elemento.numeroDocum} ={">"} {props.elemento.descrRecurso}</option>
  )
};

const ListaTipo = ({styles, handleChangeRPT, list, numeroDocumUA}) => {
  const NivelDetalleTipo = list.map((elemento, _id) => <DetalleNivelTipo elemento={elemento} key={elemento._id} />);
  if(numeroDocumUA === "Todos..."){
    return(
      <div>
        <select style={styles.input} className="ui simple selection dropdown fluid" name="tercero" id="miLista" onChange={(ev)=>handleChangeRPT(ev)}>
          <option style={styles.input} value="">Seleccionar...</option>
          {NivelDetalleTipo}
        </select>
      </div>
    )
  }else{
    return(
      <div>
        <select style={styles.input} className="ui simple selection dropdown fluid" name="tercero" id="miLista" onChange={(ev)=>handleChangeRPT(ev)}>
          {NivelDetalleTipo}
        </select>
      </div>
    )
  }
};

const RecPagoCli = ({styles, elemento, permAct, handleChangeColecc}) => {
  let fechaM = elemento.fechaMov.substr(0,10)
  const valorValido = (valor) => {
    if(valor){
      return valor
    }else{
      return 0
    }
  }
  return(
    <tr className=''>
      <td className=''>{elemento.numeroOdeDX>0?elemento.numeroOdeDX:""}</td>
      <td className=''>{fechaM}</td>
      <td className=''>{elemento.descripcionServicio}</td>
      <td className=''>{elemento.origen}</td>
      <td className=''>{elemento.periodo}</td>
      <td className='' style={elemento.valorTotal<0?{color: 'yellow'}:{color: '#FAFFD1', fontWeight: 'bold'}}>{elemento.valorTotal}</td>
      <td className=''>{elemento.valorPagado}</td>
      <td className=''>{elemento.valorTotal - elemento.valorPagado}</td>
      <td className='center aligned' style={styles.styPaddMarg}>
        <input type='number' step="1" style={styles.styInput} autoComplete="off" name="valorRecibido" id={elemento._id} value={valorValido(elemento.valorRecibido)} placeholder='Paga' onChange={permAct==='cambiar'?(ev)=>handleChangeColecc(ev, elemento):()=>{}}/>
      </td>
    </tr>
  )
};

const ListaRecPago = ({styles, list, permAct, handleChangeColecc}) => {
  const nivel1Detalle = list.map((elemento, _id) => <RecPagoCli styles={styles} elemento={elemento} permAct={permAct} handleChangeColecc={handleChangeColecc} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//dropdown OFICINAS
const DetalleOf1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrOficina}</option>
  )
};

const ListaOf = ({styles, list, handleChangeOf}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleOf1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="oficina" id="miListaOf" onChange={(ev)=>handleChangeOf(ev)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown OFICINAS

class ProcPagoTer2 extends React.Component {
  state={
    argsBuscarMC: {},
    argsAdd: {fechaPago: "", fechaMin: "", fechaHoy: "", ultDiaMes: 28, descrOficina: this.props.descrOficina, valorEf: 0, valorCh: 0, valorTr: 0, valorTC: 0, valorTD: 0},
    confirmaAct: false, listColecc: [],
    open: false
  }

  handleChange = (ev, totRecibido, list4)=>{
    // console.log(ev.target.value)
    // console.log(ev.target.name)
    let listColecc = list4.map(recpago => ({...recpago}))
    if(ev.target.name==="valorEf"||ev.target.name==="valorCh"||ev.target.name==="valorTr"||
        ev.target.name==="valorTC"||ev.target.name==="valorTD"){
      let totRecib = 0, valorRdo = 0, valorRdoEf = 0, valorRdoCh = 0, valorRdoTr = 0, valorRdoTC = 0, valorRdoTD = 0
      if(ev.target.value){valorRdo=ev.target.value}
      if(this.state.argsAdd.valorEf){valorRdoEf=this.state.argsAdd.valorEf}
      if(this.state.argsAdd.valorCh){valorRdoCh=this.state.argsAdd.valorCh}
      if(this.state.argsAdd.valorTr){valorRdoTr=this.state.argsAdd.valorTr}
      if(this.state.argsAdd.valorTC){valorRdoTC=this.state.argsAdd.valorTC}
      if(this.state.argsAdd.valorTD){valorRdoTD=this.state.argsAdd.valorTD}
      if(ev.target.name==="valorEf") {
        totRecib = parseInt(totRecibido, 10) - parseInt(valorRdoEf, 10) + parseInt(valorRdo, 10)
      }
      if(ev.target.name==="valorCh") {
        totRecib = parseInt(totRecibido, 10) - parseInt(valorRdoCh, 10) + parseInt(valorRdo, 10)
      }
      if(ev.target.name==="valorTr") {
        totRecib = parseInt(totRecibido, 10) - parseInt(valorRdoTr, 10) + parseInt(valorRdo, 10)
      }
      if(ev.target.name==="valorTC") {
        totRecib = parseInt(totRecibido, 10) - parseInt(valorRdoTC, 10) + parseInt(valorRdo, 10)
      }
      if(ev.target.name==="valorTD") {
        totRecib = parseInt(totRecibido, 10) - parseInt(valorRdoTD, 10) + parseInt(valorRdo, 10)
      }

      listColecc.forEach((elemento, i) => {
        if(elemento.valorTotal<0){
          totRecib -= elemento.valorTotal
          listColecc[i].valorRecibido = elemento.valorTotal
        }
      })
  
      listColecc.forEach((elemento, i) => {
        if(elemento.valorTotal>0){
          if(totRecib > elemento.valorTotal - elemento.valorPagado){
            totRecib -= (elemento.valorTotal - elemento.valorPagado)
            listColecc[i].valorRecibido = elemento.valorTotal - elemento.valorPagado
          }else{
            listColecc[i].valorRecibido = totRecib
            totRecib = 0
          }
        }
      })
    }

    const argsAdd = this.state.argsAdd
    if(ev.target.name==="valorEf"||ev.target.name==="valorCh"||ev.target.name==="valorTr"||
        ev.target.name==="valorTC"||ev.target.name==="valorTD"){
      argsAdd[ev.target.name] = parseInt(ev.target.value, 10)
    }else{
      argsAdd[ev.target.name] = ev.target.value
    }

    // const argsAdd = this.state.argsAdd
    // if(ev.target.name==="rango"){
    //   var miLista = document.getElementById("miListaR");
    //   argsAdd['_idRango'] = miLista.options[miLista.selectedIndex].attributes[0].value
    // }else{
    //   argsAdd[ev.target.name] = ev.target.value
    //   argsAdd['contrato'] = this.props.idLista.contrato
    // }

    this.setState({listColecc, argsAdd});
  }

  handleChangeRPT = async (ev) => {
    let argsAdd = this.state.argsAdd
    // console.log(ev.target.name)
    // console.log(ev.target.value)
    // console.log(this.props.numeroDocumUA)

    if(ev.target.name === "tercero"||this.props.numeroDocumUA !== "Todos..."){
      var miLista = document.getElementById("miLista");
      // argsAdd['_idTercero'] = miLista.options[miLista.selectedIndex].value
      argsAdd['numeroDocum'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['descrRecurso'] = miLista.options[miLista.selectedIndex].attributes[1].value
    }
    if(ev.target.name === "numeroRT"){
      argsAdd.numeroRT=ev.target.value
    }
    if(ev.target.name === "fechaPago"){
      argsAdd['fechaPago']=ev.target.value
    }

    if(ev.target.name === "contrato"){
      // console.log(ev.target.name)
      var numeroRT = document.getElementById("numeroRT");
      argsAdd.numeroRT=numeroRT.value
      argsAdd.valorEf=0
      argsAdd.valorCh=0
      argsAdd.valorTr=0
      argsAdd.valorTC=0
      argsAdd.valorTD=0

      delete argsAdd.numeroCh
      delete argsAdd.bancoCh
      delete argsAdd.fechaVencCh
      delete argsAdd.bancoTr
      delete argsAdd.fechaTr
      delete argsAdd.bancoTD
      delete argsAdd.bancoTC

      let argsBuscar={}
      //se asigna numDocum=1327 para controlar busqueda exacta del contrato
      argsBuscar.numDocum=1327
      if(ev.target.value){
        argsBuscar.contrato=ev.target.value
      }else{
        argsBuscar.contrato=null
      }
      argsBuscar.nombreCliente=null
      argsBuscar.apellidoCliente=null
      argsBuscar.descrClaseServ=null
      argsBuscar.descrSubclaseServ=null
      if(this.props.codigoDptoUA!=="Todos..."){
        argsBuscar.descrDpto=this.props.args.descrDpto
      }
      if(this.props.codigoCiudadUA!=="Todas..."){
        argsBuscar.nombreCiudad=this.props.args.nombreCiudad
      }

      const argsBuscarMC = this.state.argsBuscarMC
      argsBuscarMC.orden='+_id'
      if(ev.target.value){
        argsBuscarMC.contrato=ev.target.value
        argsAdd.contrato=ev.target.value
      }else{
        argsBuscarMC.contrato=null
        // argsAdd = {}
      }

      // await this.props.allClientes1.refetch(argsBuscar)
      // if(this.props.allClientes1.allClientes.length===1){
      //   let aleatorio1 = parseInt(Math.random() * (9999999 - 1000000) + 1000000, 10)
      //   sessionStorage.setItem("aleatorio1", aleatorio1);
      // console.log(aleatorio1)
      // }
      let listClientes = []
      let {data} = await this.props.allClientes1.refetch(argsBuscar)
      if(data!==undefined){
        listClientes = await data.allClientes
        if(listClientes.length===1){
          let aleatorio1 = parseInt(Math.random() * (9999999 - 1000000) + 1000000, 10)
          sessionStorage.setItem("aleatorio1", aleatorio1);
          // console.log(aleatorio1)
        }
      }

      await this.props.allMovClientes1.refetch(argsBuscarMC)
      let listColecc = await this.props.allMovClientes1.allMovClientes
      listColecc = await listColecc.filter(elemento => elemento.tipo==="C" && elemento.valorTotal!==elemento.valorPagado)

      this.setState({argsBuscarMC});
      this.setState({listColecc});
    }
    this.setState({argsAdd});
    // console.log(this.state.argsAdd)
  }

  handleChangeColecc = (ev, elemento) => {
    if(ev.target.name === "valorRecibido"){
      let listColecc = this.state.listColecc.map(recpago => ({...recpago}))
      const indexSearch = listColecc.findIndex( pagar => pagar._id === ev.target.id );
      listColecc[indexSearch].valorRecibido = ev.target.value

      this.setState({listColecc});
    }
  }

  handleChangeOf = (ev) => {
    if(ev.target.name === "oficina"){
      const argsAdd = this.state.argsAdd
      let miLista = document.getElementById("miListaOf");
      argsAdd['descrOficina'] = miLista.options[miLista.selectedIndex].text  
      this.setState({argsAdd, confirmaAct: false});
    }
  }

  handleRefresh = (totRecibido, list4) => {
    let listColecc = list4.map(recpago => ({...recpago}))
    let totRecib = totRecibido
    listColecc.forEach((elemento, i) => {
      if(elemento.valorTotal<0){
        totRecib -= elemento.valorTotal
        listColecc[i].valorRecibido = elemento.valorTotal
      }
    })

    listColecc.forEach((elemento, i) => {
      if(elemento.valorTotal>0){
        if(totRecib > elemento.valorTotal - elemento.valorPagado){
          totRecib -= (elemento.valorTotal - elemento.valorPagado)
          listColecc[i].valorRecibido = elemento.valorTotal - elemento.valorPagado
        }else{
          listColecc[i].valorRecibido = totRecib
          totRecib = 0
        }
      }
    })

    this.setState({listColecc});
  }
  
  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  async UNSAFE_componentWillMount(){
    if(this.state.argsAdd.fechaPago===""){
      const argsAdd = this.state.argsAdd
      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaFechaHoy} = await response.data.fecha

      let fechaHoy = fechaFechaHoy.substr(0, 10)

      let numdiasUltDX = 1000*60*60*24*2
      let fechaMin = new Date(fechaFechaHoy.substr(0,10)).getTime();
      fechaMin = new Date(fechaMin - numdiasUltDX)
      fechaMin = (fechaMin.getFullYear()) + '-' + ((fechaMin.getMonth()+1)<10?'0'+(fechaMin.getMonth()+1):(fechaMin.getMonth()+1)) + '-' + (fechaMin.getUTCDate()<10?'0'+fechaMin.getUTCDate():fechaMin.getUTCDate())
      argsAdd['fechaPago'] = fechaHoy
      argsAdd['fechaMin'] = fechaMin
      argsAdd['fechaHoy'] = fechaHoy

      const ultDiaMes = getNumDiasMes(fechaHoy.substr(5, 2), fechaHoy.substr(0, 4))
      argsAdd['ultDiaMes'] = ultDiaMes

      this.setState(argsAdd)
    }
  }
render(){
  const {argsAdd, listColecc} = this.state;
// console.log(clienteSel)
let cliRPT = []
if(this.props.allClientes1.allClientes){
  cliRPT = this.props.allClientes1.allClientes
}
let clienteOK = false
let clienteSel = []

let estadoCliente = ""
let saldoPendiente = ""

let linea1DNN = ""
let linea2DNN = ""
let linea3DNN = ""
let linea4DNN = ""
let direccion1 = ""
let direccion2 = ""

let totRecibido = 0

let argsDocumCli = {}

if(cliRPT.length===1){
  clienteOK = true
  clienteSel = cliRPT[0]

  estadoCliente = clienteSel.estadoCliente
  saldoPendiente = clienteSel.saldoPendiente

  argsDocumCli = {contrato: clienteSel.contrato,
    nombreCliente: clienteSel.nombreCliente,
    apellidoCliente: clienteSel.apellidoCliente,
    telefono1: !clienteSel.telefono1?'':clienteSel.telefono1,
    telefono2: !clienteSel.telefono2?'':clienteSel.telefono2,
    telefono3: !clienteSel.telefono3?'':clienteSel.telefono3,
    observaciones: !clienteSel.observaciones?'':clienteSel.observaciones,
    _id: clienteSel._id}

  if(clienteSel.direccion.descrTipoVia1){
    linea1DNN = `${clienteSel.direccion.descrTipoVia1?clienteSel.direccion.descrTipoVia1:""}
      ${clienteSel.direccion.numeroTipoVia1?clienteSel.direccion.numeroTipoVia1:""}
      ${clienteSel.direccion.descrTipoVia2?clienteSel.direccion.descrTipoVia2:""}
      ${clienteSel.direccion.numeroTipoVia2?clienteSel.direccion.numeroTipoVia2:""}
      ${clienteSel.direccion.numeroTipoVia2F?clienteSel.direccion.numeroTipoVia2F:""}
      ${clienteSel.direccion.descrTipoUnd1?clienteSel.direccion.descrTipoUnd1:""}
      ${clienteSel.direccion.numeroTipoUnd1?clienteSel.direccion.numeroTipoUnd1:""}
      ${clienteSel.direccion.descrTipoUnd2?clienteSel.direccion.descrTipoUnd2:""}
      ${clienteSel.direccion.numeroTipoUnd2?clienteSel.direccion.numeroTipoUnd2:""}`

    linea2DNN = `${clienteSel.direccion.descrTiUndMat?clienteSel.direccion.descrTiUndMat:""}
      ${clienteSel.direccion.descrUndMat?clienteSel.direccion.descrUndMat:""}`
      
    linea3DNN = `${clienteSel.dirmayor.descrDpto?clienteSel.dirmayor.descrDpto:""}
      ${clienteSel.dirmayor.ciudades.nombreCiudad?", " + clienteSel.dirmayor.ciudades.nombreCiudad:""}`

    linea4DNN = `${clienteSel.dirmayor.ciudades.zonas.nombreZona?", Zona: " + clienteSel.dirmayor.ciudades.zonas.nombreZona:""}
      ${clienteSel.dirmayor.ciudades.zonas.barrios.nombreBarrio?", Barrio: " + clienteSel.dirmayor.ciudades.zonas.barrios.nombreBarrio:""}`

    direccion1 = linea1DNN + ' ' + linea2DNN
    direccion2 = linea3DNN + ' ' + linea4DNN
  }

  if(argsAdd.valorEf) {
    totRecibido += parseInt(argsAdd.valorEf, 10)
  }
  if(argsAdd.valorCh) {
    totRecibido += parseInt(argsAdd.valorCh, 10)
  }
  if(argsAdd.valorTr) {
    totRecibido += parseInt(argsAdd.valorTr, 10)
  }
  if(argsAdd.valorTC) {
    totRecibido += parseInt(argsAdd.valorTC, 10)
  }
  if(argsAdd.valorTD) {
    totRecibido += parseInt(argsAdd.valorTD, 10)
  }
}

let diaHoy = parseInt(argsAdd.fechaHoy.substring(8, 10), 10)

// console.log(diaHoy, argsAdd.ultDiaMes, argsAdd.fechaPago)
// console.log(argsAdd)
// console.log(this.props.args)
  return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
        <i className="large hand point down yellow icon"></i>
        Recibir pago - Terceros
      </button>
      <div>

      <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
        <div>
          <div className='ui blue inverted raised segment'>
            <Form>
              <Form.Field>
                {this.props.empresa.empresaArchFE!=="sinergy" &&
                  <div className="ui four column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '35%'}}>
                        <label style={this.props.styles.label}>Tercero</label>
                        <ListaTipo list={this.props.list7} numeroDocumUA={this.props.numeroDocumUA}
                                        styles={this.props.styles} handleChangeRPT={this.handleChangeRPT}/>
                      </div>
                      <div className="column" style={{width: '20%'}}>
                        <label style={this.props.styles.label}># Recibo</label>
                        <input style={this.props.styles.input} autoComplete="off" name="numeroRT" id="numeroRT" onChange={this.handleChangeRPT} placeholder='# Recibo'/>
                      </div>
                      {(!this.props.descrOficina||this.props.descrOficina==="Todas...") &&
                        <div className="column" style={{width: '25%'}}>
                          <label style={this.props.styles.label}>Oficina</label>
                          <Form.Field>
                            <ListaOf styles={this.props.styles} list={this.props.listaOf} handleChangeOf={this.handleChangeOf}/>
                          </Form.Field>
                        </div>
                      }
                      <div className="column" style={{width: '20%'}}>
                        <label style={this.props.styles.label}>Contrato</label>
                        <input autoFocus style={this.props.styles.input} autoComplete="off" name="contrato" id="contrato" onChange={this.handleChangeRPT} onFocus={this.handleChangeRPT} placeholder='Contrato'/>
                      </div>
                    </div>
                  </div>
                }
                {this.props.empresa.empresaArchFE==="sinergy" &&
                  <div className="ui five column stackable grid">
                    <div className="row container">
                      <div className="column" style={{width: '30%'}}>
                        <label style={this.props.styles.label}>Tercero</label>
                        <ListaTipo list={this.props.list7} numeroDocumUA={this.props.numeroDocumUA}
                                        styles={this.props.styles} handleChangeRPT={this.handleChangeRPT}/>
                      </div>
                      <div className="column" style={{width: '15%'}}>
                        <label style={this.props.styles.label}># Recibo</label>
                        <input style={this.props.styles.input} autoComplete="off" name="numeroRT" id="numeroRT" onChange={this.handleChangeRPT} placeholder='# Recibo'/>
                      </div>
                      {(!this.props.descrOficina||this.props.descrOficina==="Todas...") &&
                        <div className="column" style={{width: '20%'}}>
                          <label style={this.props.styles.label}>Oficina</label>
                          <Form.Field>
                            <ListaOf styles={this.props.styles} list={this.props.listaOf} handleChangeOf={this.handleChangeOf}/>
                          </Form.Field>
                        </div>
                      }
                      <div className="column" style={{width: '15%'}}>
                        <label style={this.props.styles.label}>Contrato</label>
                        <input autoFocus style={this.props.styles.input} autoComplete="off" name="contrato" id="contrato" onChange={this.handleChangeRPT} onFocus={this.handleChangeRPT} placeholder='Contrato'/>
                      </div>
                      {(diaHoy===argsAdd.ultDiaMes||diaHoy===1||diaHoy===2) &&
                        <div className="column" style={{width: '20%'}}>
                          <label style={this.props.styles.label}>Fecha de pago</label>
                          <input style={this.props.styles.input} type='date' name="fechaPago" id="fechaPago" value={argsAdd.fechaPago} min={argsAdd.fechaMin} max={argsAdd.fechaHoy} onChange={this.handleChangeRPT}/>
                        </div>
                      }
                    </div>
                  </div>
                }
              </Form.Field>
            </Form>

            {
                this.props.errors.length?<Message negative header="Los siguientes errores:"
                list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }

          </div>
          {clienteOK &&
          <div>

          <Divider />

          <h1 style={styles1.paraH1}>
            {argsDocumCli.contrato} - {argsDocumCli.nombreCliente} {argsDocumCli.apellidoCliente} - &nbsp;&nbsp;
            <span style={estadoCliente!=='ACTIVO'?styles1.paraH2_02:styles1.paraH2_01}>
              {estadoCliente}
            </span>
          </h1>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '65%'}}>
                <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0.7em'}}>
                  {direccion1}<br/>
                  {direccion2}
                </p>
              </div>
              <div className="column" style={{width: '35%'}}>
                <p>
                  <span style={{background: '#7F7FD5', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                    Saldo: &nbsp;&nbsp;
                    <span style={{color: '#302b63', fontSize: '2em'}}> ${general.formatNum(saldoPendiente.toString())}</span>
                  </span>
                </p>
              </div>
            </div>
          </div>


          {/* {(saldoPendiente<=0) &&
            <div>

                  <Divider inverted />
              <div className="ui one column stackable grid">
                <div className="row container">
                    <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    &nbsp;&nbsp;&nbsp;&nbsp;El cliente debe tener saldo pendiente mayor que cero
                    </p>
                </div>
              </div>
              <hr></hr>
            </div>
          } */}

          {/* {(saldoPendiente>0) && */}
          <Form onSubmit={(ev)=>{this.props.handleSubmit(ev, argsAdd, listColecc, totRecibido, clienteSel)}}>
            <div>
              <hr></hr>

              <div className="ui two column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '25%'}}>
                  <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Recibir pago
                  </p>
                  </div>
                  <div className="column" style={{width: '45%'}}>
                    <p>
                      <span style={{background: '#7F7FD5', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                        Total recibido: &nbsp;&nbsp;
                        <span style={{color: '#302b63', fontSize: '2em'}}> ${totRecibido}</span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div className='ui blue inverted raised segment'>
                    <div className="ui one column stackable grid">
                        <div className="row container">
                            <div className="column" width="100%">
                              <Form.Field>
                                <div className="column" style={{width: '23%'}}>
                                  <label style={this.props.styles.label}>$ Efectivo</label>
                                  <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorEf" id="valorEf" placeholder='Efectivo' onChange={(ev) => this.handleChange(ev, totRecibido, listColecc)}/>
                                </div>
                              </Form.Field>
                              <Form.Field>
                                <div className="ui four column stackable grid">
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>$ Cheque</label>
                                    <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorCh" id="valorCh" placeholder='Cheque' onChange={(ev) => this.handleChange(ev, totRecibido, listColecc)}/>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}># cheque</label>
                                    <input style={this.props.styles.input} autoComplete="off" name="numeroCh" id="numeroCh" onChange={(ev) => this.handleChange(ev, totRecibido, listColecc)} placeholder='# cheque'/>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>Banco</label>
                                    <input style={this.props.styles.input} autoComplete="off" name="bancoCh" id="bancoCh" onChange={(ev) => this.handleChange(ev, totRecibido, listColecc)} placeholder='Banco'/>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>Fecha vencimiento</label>
                                    <input style={this.props.styles.input} type='date' name="fechaVencCh" id="fechaVencCh" onChange={(ev) => this.handleChange(ev, totRecibido, listColecc)}/>
                                  </div>
                                </div>
                              </Form.Field>
                              <Form.Field>
                                <div className="ui four column stackable grid">
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>$ Transferencia</label>
                                    <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorTr" id="valorTr" placeholder='Transferencia' onChange={(ev) => this.handleChange(ev, totRecibido, listColecc)}/>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>Banco</label>
                                    <input style={this.props.styles.input} autoComplete="off" name="bancoTr" id="bancoTr" onChange={(ev) => this.handleChange(ev, totRecibido, listColecc)} placeholder='Banco'/>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>Fecha transferencia</label>
                                    <input style={this.props.styles.input} type='date' name="fechaTr" id="fechaTr" onChange={(ev) => this.handleChange(ev, totRecibido, listColecc)}/>
                                  </div>
                                </div>
                              </Form.Field>
                              <Form.Field>
                                <div className="ui four column stackable grid">
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>$ Tarjeta débito</label>
                                    <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorTD" id="valorTD" placeholder='Valor' onChange={(ev) => this.handleChange(ev, totRecibido, listColecc)}/>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>Banco</label>
                                    <input style={this.props.styles.input} autoComplete="off" name="bancoTD" id="bancoTD" onChange={(ev) => this.handleChange(ev, totRecibido, listColecc)} placeholder='Banco'/>
                                  </div>
                                </div>
                              </Form.Field>
                              <Form.Field>
                                <div className="ui four column stackable grid">
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>$ Tarjeta crédito</label>
                                    <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorTC" id="valorTC" placeholder='Valor' onChange={(ev) => this.handleChange(ev, totRecibido, listColecc)}/>
                                  </div>
                                  <div className="column" style={{width: '25%'}}>
                                    <label style={this.props.styles.label}>Banco</label>
                                    <input style={this.props.styles.input} autoComplete="off" name="bancoTC" id="bancoTC" onChange={(ev) => this.handleChange(ev, totRecibido, listColecc)} placeholder='Banco'/>
                                  </div>
                                </div>
                              </Form.Field>
                            </div>
                        </div>
                    </div>
              </div>

              <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className=''>DX</th>
                    <th className=''>Fecha</th>
                    <th className=''>Servicio</th>
                    <th className=''>Concepto</th>
                    <th className=''>Periodo</th>
                    <th className=''>Valor</th>
                    <th className=''>Pagado</th>
                    <th className=''>Debe</th>
                    <th className='center aligned'>&nbsp;&nbsp;
                      <button className="ui right labeled icon button" type="button" style={this.props.styles.styBtn} onClick={() => this.handleRefresh(totRecibido, listColecc)}>
                        <i className='redo icon'></i>
                        Paga
                      </button>
                      {/* <a className='ui large label' style={this.props.styles.styTableInf}><i className='redo icon' onClick={() => this.handleRefresh(totRecibido, listColecc)}/></a> */}
                    </th>
                  </tr>
                </thead>
                {/* <ListaRecPago styles={this.props.styles} list={listColecc} permAct='cambiar' handleChangeColecc={this.handleChangeColecc}/> */}
                <ListaRecPago styles={this.props.styles} list={listColecc} permAct='NOcambiar' handleChangeColecc={this.handleChangeColecc}/>
              </table>
            </div>

            <hr></hr>

            {/* <Button style={{color: '#FDC830', background: 'linear-gradient(#000046, #1CB5E0)'}} style={this.props.styles.confirmar} type='submit' fluid> */}
            <Button style={this.props.styles.confirmar} type='submit' fluid>
                Recibir pago
            </Button>
            </Form>

            {
                this.props.errors.length?<Message negative header="Los siguientes errores:"
                list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }
            </div>
          }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allClientes, {name:'allClientes1', options: (props) => {return {variables: {numDocum: 50}}}}),
  graphql(queries.query.allMovClientes, {name:'allMovClientes1', options: (props) => {return {variables: {orden: '-_id'}}}}),

    //Aunque no se necesita, se deja createCliente para mantener  la posibilidad de agregar querys
    graphql(queries.mutation.createCliente, {name:'createCliente'}),
    // graphql(queries.mutation.editCliente, {name:'editCliente'}),
    // graphql(queries.mutation.createServicio, {name:'createServicio'}),

    graphql(queries.mutation.fecha, {name:'fecha'}),
  )(ProcPagoTer2)